module.exports = __webpack_public_path__ + "static/media/custom3.ca5f8268.png";